import { AnyQuestion } from "@r6digital/rapidstor-types/types/Questionnaire";
import React from "react";
import MultipleChoiceQuestion from "./MultipleChoiceQuestion";
import NumberQuestion from "./NumberQuestion";
import CheckboxesQuestion from "./CheckboxesQuestion";
import classes from "./Question.module.scss";

interface Props {
  id: string;
  question: AnyQuestion;
}

function getQuestionElement(id: string, question: AnyQuestion) {
  if (question.type === "multiple-choice") {
    return <MultipleChoiceQuestion id={id} question={question} />;
  } else if (question.type === "number") {
    return <NumberQuestion id={id} question={question} />;
  } else if (question.type === "checkboxes") {
    return <CheckboxesQuestion id={id} question={question} />;
  }
}

function Question({ id, question }: Props) {
  return <div className={classes.question}>{getQuestionElement(id, question)}</div>;
}

export default Question;
